import { createContext, useContext } from 'react'

export type GetDateTooltipFn = (date: Date) => React.ReactNode | undefined

export const DateTooltipContext = createContext<GetDateTooltipFn | undefined>(undefined)

export const useDateTooltip = () => useContext(DateTooltipContext)
